import { ca } from '@cian/analytics';

export const trackRailwayPopupOpened = () =>
  ca('event', {
    action: 'railway_open',
    category: 'FilterPopup',
    label: '',
    name: 'oldevent',
  });

export const trackRailwayPopupClosed = () =>
  ca('event', {
    action: 'railway_close',
    category: 'FilterPopup',
    label: '',
    name: 'oldevent',
  });

// Начало ввода запроса
export const trackRailwaySearchKeypress = () =>
  ca('event', {
    action: 'railway_suggest',
    category: 'FilterPopup',
    label: 'Keypress',
    name: 'oldevent',
  });

export const trackRailwaySuggestChosen = () =>
  ca('event', {
    action: 'railway_suggest',
    category: 'FilterPopup',
    label: 'Choose',
    name: 'oldevent',
  });

export const trackRailwaySearchEmpty = () =>
  ca('event', {
    action: 'railway_suggest',
    category: 'FilterPopup',
    label: 'Nothingfound',
    name: 'oldevent',
  });

// Выбор направления ЖД
export const trackRailwayDirectionChanged = () =>
  ca('event', {
    action: 'railway_select',
    category: 'FilterPopup',
    label: 'Direction',
    name: 'oldevent',
  });

// Выбор расстояния от КП до станции в попапе
export const trackPopupRailwayDistanceChanged = () =>
  ca('event', {
    action: 'railway_select',
    category: 'FilterPopup',
    label: 'Distance',
    name: 'oldevent',
  });

// Выбор группы расстояния целиком
export const trackRailwayGroupSelected = (label: string = '') =>
  ca('event', {
    action: 'railway_select_full',
    category: 'FilterPopup',
    label,
    name: 'oldevent',
  });

export const trackRailwayPartSelected = (label: string = '') =>
  ca('event', {
    action: 'railway_select_part',
    category: 'FilterPopup',
    label,
    name: 'oldevent',
  });
